module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-8-3728dbadb1402922e744217eb2cddb51.jpg";